import { createReducer, on } from '@ngrx/store';
import * as AuthActions from './actions';
import { User } from '../../models';

export const featureKey = 'auth';

export interface State {
	user: User | null | undefined;
}

export const initialState: State = {
	user: undefined,
};

export const reducer = createReducer(
	initialState,

	on(AuthActions.set, (state, { user }) => ({
		...state,
		user,
	}))
);
